import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, forwardRef, useBreakpointValue, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { STATUSES_TO_COLOR_SCHEME } from '../internal/Status';
import { Context } from './context';
import { DEFAULT_PROPS } from './types';
export { ToastCloseButton } from './ToastCloseButton';
export { ToastContent } from './ToastContent';
export { ToastDescription } from './ToastDescription';
export { ToastDivider } from './ToastDivider';
export { ToastIcon } from './ToastIcon';
export { ToastLeftContent } from './ToastLeftContent';
export { ToastRightContent } from './ToastRightContent';
export { ToastTitle } from './ToastTitle';
export const Toast = forwardRef(({ status: responsiveStatus, variant: responsiveVariant = DEFAULT_PROPS.variant, ...props }, ref) => {
    const { colorMode } = useColorMode();
    const status = (useBreakpointValue(responsiveStatus) ??
        responsiveStatus);
    const variant = useBreakpointValue(responsiveVariant) ?? responsiveVariant;
    return (_jsx(Context.Provider, { value: { status }, children: _jsx(Flex, { ref: ref, bg: theme.colors[colorMode].layer[3].default, color: theme.colors[colorMode].text.primary, borderRadius: theme.sizes['2'], overflow: "hidden", ...(variant === 'left-accent' && {
                boxShadow: `-${theme.sizes['1']} ${theme.sizes['0']} ${theme.sizes['0']} ${theme.sizes['0']} ${theme.colors[colorMode].support[STATUSES_TO_COLOR_SCHEME[status]][4]}, ${theme.colors[colorMode].shadow[2]}`,
            }), ...(variant === 'bottom-accent' && {
                boxShadow: `${theme.sizes['0']} ${theme.sizes['1']} ${theme.sizes['0']} ${theme.sizes['0']} ${theme.colors[colorMode].support[STATUSES_TO_COLOR_SCHEME[status]][4]}, ${theme.colors[colorMode].shadow[2]}`,
                mb: theme.sizes['1'],
            }), ...props }) }));
});
